import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {HttpClientModule} from '@angular/common/http';
import {NgbModalModule} from '@ng-bootstrap/ng-bootstrap';
import {FormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {AuthServiceConfig, GoogleLoginProvider, SocialLoginModule} from 'angular-6-social-login';
import {HashLocationStrategy, Location, LocationStrategy} from '@angular/common';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {AllotmentsComponent} from './allotments/allotments.component';
import {ReportsComponent} from './reports/reports.component';
import {HomeComponent} from './home/home.component';
import {PageNotFoundComponent} from './not-found.component';
import {LoginComponent} from './login/login.component';
import {AccessService} from './services/access.service';
import {AuthenticationService} from './services/authentication.service';
import {AccessDeniedComponent} from './access-denied';
import {ToastrModule, ToastNoAnimation, ToastNoAnimationModule} from 'ngx-toastr';
import {ReportsModule} from './reports/reports.module';
import {ApplicationFormComponent} from './application-form/application-form.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {FileUploadModule, PickListModule, TooltipModule} from 'primeng/primeng';
import {ToastModule} from 'primeng/toast';
import {MessageService} from 'primeng/api';
import {DataManagementModule} from './data-management/data-management.module';
import {DataManagementComponent} from './data-management/data-management.component';
import {AllotmentsModule} from './allotments/allotments.module';
import {UtilityComponent} from './utility/utility.component';
import {UtilityModule} from './utility/utility.module';
import {NominationsComponent} from './nominations/nominations.component';
import {PastStudentsComponent} from './past-students/past-students.component';
import {CourseBiddingComponent} from './course-bidding/course-bidding.component';
import {CourseComponent} from './course/course.component';
import {TermScheduleComponent} from './term-schedule/term-schedule.component';
import {TermScheduleModule} from './term-schedule/term-schedule.module';
import {DataTablesModule} from 'angular-datatables';
import {InOutActionsComponent} from './in-out-actions/in-out-actions.component';
import {InOutActionsModule} from './in-out-actions/in-out-actions.module';
import {BiddingComponent} from './bidding-settings/bidding.component';
import {BiddingModule} from './bidding-settings/bidding.module';
import {NguiAutoCompleteModule} from '@ngui/auto-complete';
import {StudentBiddingComponent} from './student-bidding/student-bidding.component';
import {BiddingRoundsComponent} from './bidding-rounds/bidding-rounds.component';
import {BiddingRoundsModule} from './bidding-rounds/bidding-rounds.module';
import {ApplicationFormOiaComponent} from './application-form-oia/application-form-oia.component';
import {FeedbackFormComponent} from './feedback-form/feedback-form.component';
import {ApplicationFormIncomingComponent} from './application-form-incoming/application-form-incoming.component';
import {ApplicationFormOiaModule} from './application-form-oia/application-form-oia.module';
import { ConfirmationComponent } from './confirmation/confirmation.component';
import {ConfirmationModule} from './confirmation/confirmation.module';
import { ForgetPasswordComponent } from './forget-password/forget-password.component';

export function getAuthServiceConfigs() {
    const config = new AuthServiceConfig([{
        id: GoogleLoginProvider.PROVIDER_ID,
        provider: new GoogleLoginProvider('237297669346-lduaq15o4a0j3q6623f2556da2u7765u.apps.googleusercontent.com')
    }]);
    return config;
}

@NgModule({
    declarations: [
        AppComponent,
        AllotmentsComponent,
        ReportsComponent,
        HomeComponent,
        PageNotFoundComponent,
        LoginComponent,
        AccessDeniedComponent,
        ApplicationFormComponent,
        DataManagementComponent,
        UtilityComponent,
        NominationsComponent,
        PastStudentsComponent,
        CourseBiddingComponent,
        CourseComponent,
        TermScheduleComponent,
        InOutActionsComponent,
        BiddingComponent,
        StudentBiddingComponent,
        BiddingRoundsComponent,
        ApplicationFormOiaComponent,
        FeedbackFormComponent,
        ApplicationFormIncomingComponent,
        ConfirmationComponent,
        ForgetPasswordComponent,
    ],
    imports: [
        CommonModule,
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        NgbModalModule,
        FormsModule,
        SocialLoginModule,
        PickListModule,
        TooltipModule,
        ToastModule,
        FileUploadModule,
        NguiAutoCompleteModule,
        ToastNoAnimationModule,
        ReportsModule,
        DataManagementModule,
        ApplicationFormOiaModule,
        AllotmentsModule,
        UtilityModule,
        TermScheduleModule,
        DataTablesModule,
        InOutActionsModule,
        BiddingModule,
        BiddingRoundsModule,
        ConfirmationModule,
        ToastrModule.forRoot({
            toastComponent: ToastNoAnimation,
        }),
        HttpClientModule
    ],
    providers: [Location, {provide: LocationStrategy, useClass: HashLocationStrategy},
        AccessService, AuthenticationService, MessageService,
        {
            provide: AuthServiceConfig,
            useFactory: getAuthServiceConfigs
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}
